module.exports = __webpack_public_path__ + "assets/47391fae300106a7ba1d2eec61ec002c.svg";